import Vue from 'vue'
import axios from 'axios'
import {$themeConfig} from "@themeConfig"

const { appApiUrl } = $themeConfig.app

const axiosIns = axios.create({
    baseURL: appApiUrl,
    timeout: 100000,
})

Vue.prototype.$http = axiosIns

export default axiosIns
